import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0ca9a34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex space-x-4" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue';
import { ListingTabs } from '@/models/utility/ListingTabs';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataNavList',
  props: {
  tabs: {
    type: Object as () => ListingTabs,
    required: true,
  },
  defaultTab: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props;



const currentTab = props.defaultTab ? ref(props.defaultTab) : ref(Object.keys(props.tabs)[0]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, tabKey) => {
        return (_openBlock(), _createElementBlock("button", {
          onClick: ($event: any) => (currentTab.value = tabKey),
          class: _normalizeClass([{'bg-blue-600 text-white': _unref(currentTab) === tabKey, 'bg-gray-200 text-gray-700': _unref(currentTab) !== tabKey}, "tabLink"])
        }, _toDisplayString(tab.label), 11, _hoisted_2))
      }), 256))
    ]),
    _createElementVNode("div", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tabs[_unref(currentTab)]['component'])))
    ])
  ], 64))
}
}

})